import * as React from "react";
/**
 * React hook for force a component to re-render
 */

export function useForceUpdate() {
  var [count, setCount] = React.useState(0);
  var forceUpdate = React.useCallback(() => setCount(count + 1), [count]);
  return forceUpdate;
}
//# sourceMappingURL=use-force-update.js.map